import {
  ACTUAL_SAVE_ACTUAL_COST_BEGIN,
  ACTUAL_SAVE_ACTUAL_COST_SUCCESS,
  ACTUAL_SAVE_ACTUAL_COST_FAILURE,
  ACTUAL_SAVE_ACTUAL_COST_DISMISS_ERROR,
} from './constants';


import{ SERVER_PATH,AXIOS_CONFIG } from '../../common/redux/constantes';
import axios from 'axios';
import {CREATE_PROJECT_MODEL_ACTION_CREATE} from '../../common/redux/constantes';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function saveActualCost(actual_cost, action, args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: ACTUAL_SAVE_ACTUAL_COST_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      let URL = SERVER_PATH + '/actual_costs';
      if(action === CREATE_PROJECT_MODEL_ACTION_CREATE){
        actual_cost.actual_cost = 0;
        URL+="/create";
      }else{
        URL+="/edit";
      }

      axios.post(URL, {
        actual_cost:actual_cost
      }, AXIOS_CONFIG())
      .then(
        (res) => {
          if(res.data.success === 1)
          {
            dispatch({
              type: ACTUAL_SAVE_ACTUAL_COST_SUCCESS,
              data: res,
              action_model:action
            });
            resolve(res);
          }else
          {
            dispatch({
              type: ACTUAL_SAVE_ACTUAL_COST_FAILURE,
              data: { error: "Internal error" },
              action_model:action
            });
            reject("Internal Error");
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: ACTUAL_SAVE_ACTUAL_COST_FAILURE,
            data: { error: err },
            action_model:action
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSaveActualCostError() {
  return {
    type: ACTUAL_SAVE_ACTUAL_COST_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case ACTUAL_SAVE_ACTUAL_COST_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        saveActualCostPending: true,
        saveActualCostError: null,
      };

    case ACTUAL_SAVE_ACTUAL_COST_SUCCESS:
      // The request is success
      let fragmentContent = "The actual cost has been updated with success!";
      let fragmentTitle = "Update Actual Cost";
      let paperTitle = "Update Actual Cost";
      if(action.action_model === CREATE_PROJECT_MODEL_ACTION_CREATE)
      {
        fragmentContent='The actual cost has been created with success!'
        fragmentTitle='Create Actual Cost'
        paperTitle='Create Actual Cost'
      }
      return {
        ...state,
        saveActualCostPending: false,
        saveActualCostError: null,
        fragmentContent:fragmentContent,
        fragmentTitle:fragmentTitle,
        paperTitle:paperTitle,
        savePending:false,
      };

    case ACTUAL_SAVE_ACTUAL_COST_FAILURE:
      // The request is failed
      let fragmentContentFail = "We found an error.";
      let fragmentTitleFail = "Update Actual Cost";
      let paperTitleFail = "Update Actual Cost";
      if(action.action_model === CREATE_PROJECT_MODEL_ACTION_CREATE){

        fragmentContentFail='The actual cost has not been created'
        fragmentTitleFail='Create Actual Cost'
        paperTitleFail='Create Actual Cost'
      }
      return {
        ...state,
        saveActualCostPending: false,
        saveActualCostError: action.data.error,
        savePending:false,
        fragmentContent:fragmentContentFail,
        fragmentTitle:fragmentTitleFail,
        paperTitle:paperTitleFail,
      };

    case ACTUAL_SAVE_ACTUAL_COST_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        saveActualCostError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/actual/redux/saveActualCost.js